import { KITCHEN_CHARGES_COPY } from '@/components/KitchenCharges/copy';
import { dateLabel } from '@/components/KitchenCharges/chargeDate';
import { formatMoney, formatQuantity, formatUnitPrice } from '@/components/KitchenCharges/chargeMoney';
import { entryAmount, entryLabel, isAutomaticAdjustment, isEntryIncomplete } from '@/components/KitchenCharges/chargeEntries';

const COPY = KITCHEN_CHARGES_COPY;
const GROUP_ORDER = Object.freeze(['daily', 'food', 'general']);
const NOT_FOUND = -1;
const NO_AMOUNT = 0;

function groupRank(groupKey) {
  const rank = GROUP_ORDER.indexOf(groupKey);
  return rank === NOT_FOUND ? GROUP_ORDER.length : rank;
}

function pricedTotal(line) {
  return !line.price_missing && Number.isFinite(line.total) ? line.total : NO_AMOUNT;
}

function groupSection(groupKey, lines) {
  const label = groupLabel(groupKey);
  return {
    key: groupKey,
    label,
    subtotalLabel: COPY.lines.subtotal(label),
    subtotal: lines.reduce((sum, line) => sum + pricedTotal(line), NO_AMOUNT),
    lines,
  };
}

function linesByGroup(lines) {
  return (lines || []).reduce((groups, line) => {
    if (!groups.has(line.group)) groups.set(line.group, []);
    groups.get(line.group).push(line);
    return groups;
  }, new Map());
}

export function groupLabel(groupKey) {
  return Object.prototype.hasOwnProperty.call(COPY.groups, groupKey) ? COPY.groups[groupKey] : groupKey;
}

export function groupTicketLines(lines) {
  return Array.from(linesByGroup(lines), ([groupKey, groupLines]) => groupSection(groupKey, groupLines)).sort(
    (first, second) => groupRank(first.key) - groupRank(second.key)
  );
}

export function lineRow(line, currency) {
  return {
    id: line.material_id,
    name: line.name,
    quantity: formatQuantity(line.quantity),
    price: line.price_missing ? COPY.lines.priceToConfirm : formatUnitPrice(line.unit_price, currency),
    total: line.price_missing ? COPY.lines.noValue : formatMoney(line.total, currency),
    isPriceMissing: Boolean(line.price_missing),
  };
}

export function ticketDetail(ticket, currency) {
  return {
    title: entryLabel(ticket),
    date: dateLabel(ticket.date),
    groups: groupTicketLines(ticket.lines),
    totalLabel: COPY.lines.ticketTotal,
    total: entryAmount(ticket, currency),
    isIncomplete: isEntryIncomplete(ticket),
  };
}

export function adjustmentDetail(adjustment, currency) {
  return {
    title: entryLabel(adjustment),
    date: dateLabel(adjustment.date),
    reason: adjustment.reason,
    amount: entryAmount(adjustment, currency),
    isAutomatic: isAutomaticAdjustment(adjustment),
  };
}
